import { ViewCard } from '../../../../component/common/ViewCard/view-card';
import { motion } from 'framer-motion';

//* Types imports
import type { FullProcess } from "../../../../schemas/common/process/process";

//* Utils imports
import { createSubFeaturesCards } from "../../../../utils/processPermissions/subFeatureConfig";

type ViewListCardProps = {
  processId: number;
  faculdadePermissions?: FullProcess['faculdadePermissions'];
};


export function ViewListCardResource({ processId, faculdadePermissions }: ViewListCardProps) {
  const cards = createSubFeaturesCards(faculdadePermissions, processId);
  
  return (
    <div className="container py-4">
      <div className="row g-4">
        {cards.map((card, index: number) => (
          <motion.div
            key={card.id}
            className="col-12 col-md-6 col-lg-4 col-xl-3 d-flex"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
          >
            <ViewCard
              title={card.title}
              description={card.description}
              icon={card.icon}
              routePath={card.routePath}
              backgroundColor={card.backgroundColor}
              textColor={card.textColor}
              className={card.className}
            />
          </motion.div>
        ))}
      </div>
    </div>
  );
}
